import React from 'react';
import { Hero } from '../components/home/Hero';
import { References } from '../components/home/References';
import { WhatIsDTech } from '../components/home/WhatIsDTech';
import { ProductShowcase } from '../components/home/ProductShowcase';
import { AvailabilityDelivery } from '../components/home/AvailabilityDelivery';
import { WhyDTechUnified } from '../components/home/WhyDTechUnified';
import { Applications } from '../components/home/Applications';
import { PromoPopup } from '../components/home/PromoPopup';
interface HomePageProps {
  onRequestQuote: (productId?: string) => void;
}
export function HomePage({
  onRequestQuote
}: HomePageProps) {
  return <main data-id="element-819" data-mp="36sewfr2ooq1p">
      <PromoPopup data-id="element-820" data-mp="36s5622dq8gvh" />
      <Hero onRequestQuote={() => onRequestQuote()} data-id="element-821" data-mp="31zvekhwyr8r3" />
      <References data-id="element-822" data-mp="31yalkwqarxvc" />
      <WhatIsDTech data-id="element-823" data-mp="31xr23bl011f7" />
      <ProductShowcase onRequestQuote={onRequestQuote} data-id="element-824" data-mp="2e9rf8mqt5v5w" />
      <AvailabilityDelivery onRequestQuote={() => onRequestQuote()} data-id="element-825" data-mp="2e86l2y8eoe8k" />
      <WhyDTechUnified data-id="element-826" data-mp="299vbmom0w5qv" />
      <Applications data-id="element-827" data-mp="29ao7gujg1au8" />
    </main>;
}